import UAParser, { UAParserInstance } from "ua-parser-js";

export function getUserAgent(): null | UAParserInstance  {
    if (!window?.navigator?.userAgent) {
        return null;
    }

    const parser = new UAParser(window.navigator.userAgent);
    return parser;
}